import SideBarWrapper from "../../components/SideBarWrapper/SideBarWrapper";
import WorldMap from "../../components/Home/Map";
import {Box} from "@chakra-ui/react";

const HomePage = () => {
    return (
        <SideBarWrapper>
            <Box height={"87vh"} maxHeight={"87vh"} minHeight={"87vh"}>
                <WorldMap/>
            </Box>
        </SideBarWrapper>
    )
}

export default HomePage;